/** Normas ISO gestionables por tenant. */
export type IsoStandard = 'iso9001' | 'iso14001' | 'iso27001' | 'iso45001';

export const ISO_STANDARDS: readonly IsoStandard[] = [
  'iso9001',
  'iso14001',
  'iso27001',
  'iso45001',
] as const;

export const ISO_STANDARD_LABELS: Record<IsoStandard, string> = {
  iso9001: 'ISO 9001 — Calidad',
  iso14001: 'ISO 14001 — Ambiental',
  iso27001: 'ISO 27001 — Seguridad de la información',
  iso45001: 'ISO 45001 — Seguridad y salud ocupacional',
};

export const ISO_STANDARD_SHORT_LABELS: Record<IsoStandard, string> = {
  iso9001: 'ISO 9001',
  iso14001: 'ISO 14001',
  iso27001: 'ISO 27001',
  iso45001: 'ISO 45001',
};

export const ISO_STANDARD_DESCRIPTIONS: Record<IsoStandard, string> = {
  iso9001: 'Sistema de gestión de la calidad, satisfacción del cliente y mejora continua.',
  iso14001: 'Aspectos e impactos ambientales, requisitos legales y ciclo de vida.',
  iso27001: 'Seguridad de la información, SoA (Anexo A) y controles.',
  iso45001: 'Seguridad y salud en el trabajo, incidentes y participación de trabajadores.',
};

export function isAnyStandardEnabled(
  enabledStandards: readonly string[],
  requiredStandards?: readonly IsoStandard[],
): boolean {
  if (!requiredStandards || requiredStandards.length === 0) {
    return true;
  }
  return requiredStandards.some((standard) => enabledStandards.includes(standard));
}

export function isModuleVisibleForStandards(
  permissionKey: string,
  enabledStandards: readonly string[],
  permissionStandardsMap: Record<string, IsoStandard[] | undefined>,
): boolean {
  return isAnyStandardEnabled(enabledStandards, permissionStandardsMap[permissionKey]);
}
